module.exports = __webpack_public_path__ + "static/media/eden-mill-featured.685a8c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/featured-imgs/eden-mill-featured.jpg
// module id = 473
// module chunks = 0